<template>
  <div
    class="AreaAttendance"
    :style="`font-size: ${changeDevicePixelRatio(18)}px;`"
  >
    <div class="title">
      区域出勤实况
    </div>
    <div
      ref="list"
      class="list"
    >
      <div
        v-for="item in list"
        :key="item.areaIdList"
        class="item"
      >
        <div class="subTitle">
          {{ item.areaName }}
        </div>
        <div class="txtList">
          <div class="txtItem">
            <div class="label">
              区域人数
            </div>
            <div
              :style="`font-size: ${changeDevicePixelRatio(30)}px;`"
              class="num"
            >{{ item.sumCount }}</div>
          </div>
          <div class="txtItem">
            <div class="label">
              场内人数
            </div>
            <div
              :style="`font-size: ${changeDevicePixelRatio(30)}px;`"
              class="num"
            >{{ item.inJobCount }}</div>
          </div>
          <div class="txtItem">
            <div class="label">
              进场人数
            </div>
            <div
              :style="`font-size: ${changeDevicePixelRatio(30)}px;`"
              class="num"
            >{{ item.inNum }}</div>
          </div>
          <div class="txtItem">
            <div class="label">
              出场人数
            </div>
            <div
              :style="`font-size: ${changeDevicePixelRatio(30)}px;`"
              class="num"
            >{{ item.outNum }}</div>
          </div>
          <div class="txtItem">
            <div class="label">
              考勤率
            </div>
            <div
              :style="`font-size: ${changeDevicePixelRatio(30)}px;`"
              class="num"
            >{{ item.rate }}%</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OnEvent from '../common/OnEvent'
import { areaAttendance } from '@/api/manage'
import { mapState } from 'vuex'
import { changeDevicePixelRatio } from '@/utils/changeComponentsSizeWithScale'
export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: String,
      default: ''
    },
    areaIdList: {
      type: [String, Array],
      default: ''
    },
    element: {
      type: Object,
      default: () => {}
    },
    areaAttendanceType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapState({
      projectItem: (state) => state.user.projectItem,
      canvasStyleData: (state) => state.compose.canvasStyleData
    })
  },
  watch: {
    areaIdList() {
      this.getData()
    },
    'canvasStyleData.areaIdList'() {
      this.getData()
    }
  },
  mounted() {
    console.log('areaIdList', this.areaIdList)
    this.getData()
  },
  methods: {
    changeDevicePixelRatio,
    getData() {
      const form = {
        projectId: this.projectItem.projectId,
        areaIdList: this.areaIdList
      }
      if (this.areaAttendanceType === 1) {
        form.areaIdList = this.canvasStyleData.areaIdList
      } else {
        form.areaIdList = this.areaIdList
      }
      areaAttendance(form).then((res) => {
        this.list = res.data
        this.canNotScroll()
      })
    },
    canNotScroll() {
      this.$nextTick(() => {
        const list = this.$refs.list
        if (list.scrollHeight > list.clientHeight) {
          // console.dir(list)
          this.startScroll()
        }
      })
    },
    startScroll(list) {
      this.timer = setInterval(() => {
        list.scrollTop++
        if (list.scrollTop + list.clientHeight >= list.scrollHeight) {
          setTimeout(() => {
            list.scrollTop = 0
            setTimeout(() => {
              this.startScroll()
            }, 1000)
          }, 1000)
        }
      }, 16)
    }
  }
}
</script>

<style lang="scss" scoped>
.AreaAttendance {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    font-weight: bold;
    color: #fff;
    text-align: center;
    padding: 10px 0;
  }
  .list {
    position: absolute;
    padding: 0 20px;
    top: 40px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    color: #fff;

    .item {
      margin-bottom: 10px;
      .subTitle {
        font-weight: bold;
        background: #1989fa;
        line-height: 1.5;
        padding-left: 12px;
      }
      .txtList {
        display: flex;
        .txtItem {
          flex: 1;
          .label {
            text-align: center;
            line-height: 2;
          }
          .num {
            text-align: center;
            font-size: 30px;
          }
        }
      }
    }
  }
}
</style>
